import desktopLogo from "./powered-by-desktop.svg";
import mobileLogo from "./powered-by-mobile.svg";

export function PoweredBySB() {
  return (
    <>
      <div className="mobius-header-gocompare__powered-by --is-desktop">
        <img src={desktopLogo} alt="Powered by Simply Business" />
      </div>
      <div className="mobius-header-gocompare__powered-by --is-mobile">
        <img src={mobileLogo} alt="Powered by Simply Business" />
      </div>
    </>
  );
}
